<template>
  <div>
    <div v-if="showNewRequest" class="text-left">
      <naj-button type="button" size="small" @click="openModal">
        <v-icon right v-text="`mdi-plus`"></v-icon>
        {{ local.home.tabCommon.newSubRequest }}
      </naj-button>
    </div>
    <v-row class="mx-12">
      <template>
        <v-col v-for="(subRequest, index) in subRequests" :key="index" cols="4">
          <bankruptcy-card
            :info-item="subRequest"
            :icon="'mdi-archive'"
            :header="`${local.bankruptcy.bankruptcyFile.request} ${subRequest.requestTypeName}`"
            :code-display-name="local.caseFile.cards.request.codeDisplayName"
            :code="subRequest.subRequestCode"
            :status="subRequest.requestStatusName"
            :status-display-name="local.caseFile.cards.request.statusDisplayName"
            :date="subRequest.requestDate"
            :date-display-name="local.caseFile.cards.request.dateDisplayName"
            :has-actions="true"
            :court-name="subRequest.courtName"
            :sub-circle-name="subRequest.subCircleName"
          >
            <template slot="actions" slot-scope="{}">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-icon large v-on="on">
                    mdi-dots-vertical
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item v-if="subRequest.displayInSubRequestFile">
                    <v-list-item-title>
                      <router-link
                        :to="`/bankruptcy/${subRequest.mainRequestObjectKey}/sub-request/${
                          subRequestTypeIds[subRequest.requestTypeId]
                        }/${subRequest.objectKey}?isInternal=${subRequest.isInternal}`"
                      >
                        <naj-button text type="button" size="small">
                          {{ local.bankruptcy.bankruptcyFile.requests.viewSubRequestFile }}
                        </naj-button>
                      </router-link>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="!subRequest.displayInSubRequestFile">
                    <v-list-item-title>
                      <router-link
                        :to="`/bankruptcy/${subRequest.mainRequestObjectKey}/bankruptcy-file/view-sub-request/${
                          subRequestTypeIds[subRequest.requestTypeId]
                        }/${subRequest.objectKey}?isInternal=${subRequest.isInternal}`"
                      >
                        <naj-button text type="button" size="small">
                          {{ local.common.show }}
                        </naj-button>
                      </router-link>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </bankruptcy-card>
        </v-col>
      </template>
      <v-col cols="12">
        <naj-no-data :has-data="subRequests && subRequests.length > 0" :loading="loading"></naj-no-data>
      </v-col>
    </v-row>

    <naj-confirmation
      :show-modal="showRequestModel"
      :max-width="771"
      :title="local.home.tabCommon.newSubRequest"
      :show-close-btn="false"
      @cancel="
        () => {
          selectedRequestType = {};
          selectedRequestTypeId = 0;
          showRequestFullExplanation = false;
          showRequestModel = false;
          pledged = false;
        }
      "
    >
      <template slot="message-content">
        <span class="explanation">
          {{ local.bankruptcy.subRequests.newSubRequestExplanation }}
        </span>
        <v-row>
          <v-col cols="12">
            <naj-input
              :type-id="formFieldType.selectbox"
              :label="local.bankruptcy.bankruptcyFile.requests.requestName"
              :value.sync="selectedRequestTypeId"
              :items="requestTypes"
              item-text="name"
              item-value="id"
              :disabled="false"
              @change="showCreateRequestDisclaimer"
            ></naj-input>
          </v-col>
          <v-col v-if="showRequestFullExplanation" cols="12">
            <naj-alert type="alert">
              <template slot="content">
                {{ local.lawsuitDetails.caseRelatedRequestFeesNote }}
                <a :href="Urls.judicialFees" target="_blank" class="about-link">
                  {{ local.common.clickHere }}
                </a>
              </template>
            </naj-alert>
          </v-col>
          <v-col v-if="showRequestFullExplanation" cols="12">
            <naj-input
              :type-id="formFieldType.checkbox"
              :value.sync="pledged"
              :label="selectedRequestType.fullExplanation"
            ></naj-input>
          </v-col>
        </v-row>
      </template>

      <template slot="actions">
        <naj-button :disabled="!pledged" @click="openCreateNewRequest()">
          {{ local.common.next }}
        </naj-button>
      </template>
    </naj-confirmation>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions, mapState } = createNamespacedHelpers('BankruptcyModule');
import BankruptcyCard from '../bankruptcy-card.vue';
import { subRequestTypeIds, subRequestTypesEnum, subRequestType, subRequestStatus } from '@/modules/bankruptcy/helpers/enum';
import { userType } from '@/helpers/enum';
import { Urls } from '@/modules/judicialFees/helpers/enum';

export default {
  name: 'RequestsTab',
  components: { BankruptcyCard },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
    },
    requestInfo: {
      type: Object,
      required: true,
    },
    showNewRequest: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      subRequests: [],
      subRequestTypeIds,
      subRequestTypesEnum,
      showRequestFullExplanation: false,
      pledged: false,
      selectedRequestType: {},
      subRequestType,
      userType,
      subRequestTypes: [],
      selectedRequestTypeId: 0,
      Urls,
      showRequestModel: false,
      subRequestStatus,
    };
  },
  computed: {
    ...mapState({ userInfo: (state) => state.currentUser }),
    isRequestOwner() {
      return this.requestInfo.isRequestOwner;
    },
    identityNumber() {
    return this.userInfo.userType === userType.najizOrganization
      ? this.userInfo.impersonatedBySocialId
      : this.userInfo.socialId;
    },
    requestTypes() {
     
     
      if (!this.isOrganizationUser)
        return [
          ...this.subRequestTypes.filter(
            (item) => item.id == subRequestType.AddRepresentative || item.id == subRequestType.VerdictObjectionRequest,
          ),
          subRequestTypesEnum.GeneralRequest,
        ].map((item) => {
          return {
            id: item.id,
            name: item.name,
            fullExplanation: item.fullExplanation,
            componentName: item.customComponentName,
          };
        });
      else if (this.userInfo.isBankruptcyTrustee)
        return [
          ...this.subRequestTypes.filter((item) => item.id == subRequestType.VerdictObjectionRequest),
          subRequestTypesEnum.GeneralRequest,
        ].map((item) => {
          return {
            id: item.id,
            name: item.name,
            fullExplanation: item.fullExplanation,
            componentName: item.customComponentName,
          };
        });
      else
        return [
          ...this.subRequestTypes.filter((item) => item.id == subRequestType.VerdictObjectionRequest),
          subRequestTypesEnum.GeneralRequest,
        ].map((item) => {
          return {
            id: item.id,
            name: item.name,
            fullExplanation: item.fullExplanation,
            componentName: item.customComponentName,
          };
        });
    },
    isOrganizationUser() {
      return this.userInfo.isOrganizationUser;
    },
  },
  watch: {},
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions(['getSubRequestsByRequestObjectKey', 'canIssueSubRequest', 'getValidSubRequestsForProcedure']),
    displayInSubRequestFile(statusId, requestTypeId) {
      let validSubRequestStatus = [
        subRequestStatus.rejected,
        subRequestStatus.transferredToCircuit,
        subRequestStatus.accepted,
        subRequestStatus.referredToAppealCourt,
      ];
      let notValidRequestTypes = [subRequestType.AddRepresentative];
      return validSubRequestStatus.includes(statusId) && !notValidRequestTypes.includes(requestTypeId);
    },
    loadData() {
      this.loading = true;
      let payload = {
        objectKey: this.requestInfo.objectKey,
        identityNumber: this.identityNumber,
        unifiedNumber: this.userInfo.socialId,
        isSubRequest: false,
      };
      Promise.all([this.getSubRequestsByRequestObjectKey(this.requestObjectKey), this.getValidSubRequestsForProcedure(payload)])
        .then((res) => {
          this.subRequests = res[0].data.map((item) => {
            return {
              ...item,
              displayInSubRequestFile: this.displayInSubRequestFile(item.statusId, item.requestTypeId),
            };
          });
          this.subRequestTypes = res[1].data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openModal() {
      // this.$refs.subRequestsModal.show();
      this.showRequestModel = true;
    },
    onModalClose() {
      this.markerPoint = { ...this.selectedPoint };
    },
    showCreateRequestDisclaimer(requestType) {  
      
       
      if (typeof requestType === 'undefined' || requestType === null || this.requestType === '') return;

if (requestType === subRequestTypesEnum.GeneralRequest.id) {
  this.$router.push({
        path: `/bankruptcy/${this.requestObjectKey}/categorized`,
      });
      return;
}


      this.selectedRequestType = {};
      this.showRequestFullExplanation = false;
      this.pledged = false;

      const params = {
        objectKey: this.requestObjectKey,
        requestType: requestType,
      };
      this.canIssueSubRequest(params)
        .then((res) => {
          if (res.data) {
            this.showRequestFullExplanation = true;
            this.selectedRequestType = this.subRequestTypes.find((rt) => rt.id == requestType);
          }
        })
        .finally(() => {
          this.loading = false;
        });
      
    },
    openCreateNewRequest() {
      this.showRequestFullExplanation = false;
      this.$router.push({
        path: `/bankruptcy/${this.requestObjectKey}/bankruptcy-file/${this.selectedRequestType.code}?isInternal=${true}`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.explanation {
  font-size: 18px;
  font-weight: bold;
}
</style>
